import { render, staticRenderFns } from "./BlogMainDoctor.vue?vue&type=template&id=34114de3&scoped=true"
import script from "./BlogMainDoctor.vue?vue&type=script&lang=js"
export * from "./BlogMainDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34114de3",
  null
  
)

export default component.exports